import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject
} from "@angular/core";
import { PageDetailComponent } from "src/app/components/ui/page/page-detail/page-detail.component";

@Component({
  selector: "snootas-page-detail-image",
  template: "",
  standalone: false
})
export class PageDetailImageComponent implements OnChanges {
  @Input()
  icon: string | undefined;

  @Input()
  src: string | undefined;

  @Input()
  allowEdit: boolean = false;

  @Output()
  imageChanged: EventEmitter<File> = new EventEmitter();

  pageDetail: PageDetailComponent | undefined = inject(PageDetailComponent);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.src) {
      this.pageDetail?.imageSrc.set(this.src);
    }
  }
}
